import { Box, Button, Menu, MenuButton, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiChevronDown } from "react-icons/fi";
import { useAssistantContext } from "./AssistantProvider";

export const ModelSwitcher = () => {
  const { t } = useTranslation();
  const { models, defaultModelId, selectedModelId, selectModel, isRunning } = useAssistantContext();

  if (models.length === 0) {
    return null;
  }
  const activeId = selectedModelId ?? defaultModelId;
  const activeLabel = models.find((model) => model.id === activeId)?.label ?? activeId;

  return (
    <Menu placement="bottom-end">
      <MenuButton
        as={Button}
        variant="ghost"
        size="sm"
        rightIcon={<FiChevronDown />}
        isDisabled={isRunning}
        aria-label={t("Model") ?? "Model"}
      >
        <Text fontSize="sm" color="smTextDisabled" isTruncated maxW="32">
          {activeLabel}
        </Text>
      </MenuButton>
      <MenuList>
        {models.map((model) => (
          <MenuItem
            key={model.id}
            onClick={() => selectModel(model.id)}
            isDisabled={isRunning}
            bg={model.id === activeId ? "smBackgroundSecondary" : undefined}
          >
            <Box>
              <Text fontSize="sm" color="smText">
                {model.label}
              </Text>
              {model.id === defaultModelId && (
                <Text fontSize="xs" color="smTextDisabled">
                  {t("Default")}
                </Text>
              )}
            </Box>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
